"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
export default function ClientQuote() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="client-quote" ref={ref} className="relative py-16 px-4 bg-background overflow-hidden sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className={`flex flex-col md:flex-row items-center gap-12 lg:gap-24 transition-all duration-700 ${isVisible ? 'animate-fade-in-up' : 'opacity-0'}`}>
          <img src="https://newmavericks.com/wp-content/uploads/2026/03/Mark-Waller-news.jpg" alt="Mark Waller Testimonial" className="w-full aspect-[8/9] object-contain rounded-lg shadow-strong ![margin:-30px_0px_0px_0px] md:w-1/2" />
          <div className="w-full md:w-1/2 flex flex-col justify-center">
            <p className="text-2xl font-light italic leading-relaxed !text-[hsl(0,0%,100%)] md:text-3xl">“Organizing the biggest deal in our corporate history involved long hours, tight time frames and multiple go / no-go hurdles &amp; multiple possibilities for stress. <br /><br />Despite this, I personally felt like I was the eye of the storm…all is calm and relaxed...as a result, the deal fell into place."<br /><br /><b>Mark Waller<br />Former CEO &amp; Chairman EBOS Group<br />CEO of the Year &amp; Business Hall of Fame New Zealand</b><br /></p>
          </div>
        </div>
      </div>
    </section>;
}